"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertStringToGeometry = void 0;
// Convert string to geometry
// Input example: "[[-694553.2659999989, -1122757.8625000007], [-694556.4655000009, -1122751.8093999997], [-694543.1305, -1122745.7769000009], [-694493.6433999985, -1122721.4318999983], [-694449.6165999994, -1122699.6301999986], [-694380.6130999997, -1122665.9750999995], [-694331.7179999985, -1122642.2683999985], [-694284.0452999994, -1122619.2866999991], [-694280.0766000003, -1122625.2397999987], [-694322.5489000008, -1122647.2663999982], [-694357.4739999995, -1122663.4059999995], [-694426.7949000001, -1122697.008200001], [-694495.5866999999, -1122731.1394999996], [-694553.2659999989, -1122757.8625000007]]"
// First convert it to json and then to geometry
const convertStringToGeometry = (geom) => {
    const json = JSON.parse(geom);
    const result = json;
    return result;
};
exports.convertStringToGeometry = convertStringToGeometry;
